"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletionEvaluator = void 0;
/**
 * Completion-only evaluator for activities where the act of completion
 * (visiting all pages, reading the whole story) is the success criterion.
 *
 * Score = 100 if `structuredData.pagesVisited` covers all page IDs in the
 * activity config, 0 otherwise. No auto-quiz, no comprehension scoring of
 * the reading itself — the optional workpad response is scored by the
 * workpad's own evaluator if present.
 */
class CompletionEvaluator {
    async evaluate(submission, activity) {
        const config = activity.config;
        const pages = Array.isArray(config.pages) ? config.pages : [];
        const allPageIds = pages.map(p => String(p.id));
        const visitedIds = Array.isArray(submission.structuredData?.pagesVisited)
            ? submission.structuredData.pagesVisited
            : [];
        const allVisited = allPageIds.length > 0 && allPageIds.every(id => visitedIds.includes(id));
        const score = allVisited ? 100 : 0;
        return {
            score,
            maxScore: 100,
            isCorrect: allVisited,
            feedback: allVisited
                ? 'Great reading! You read the whole story.'
                : 'Please read all the pages to finish the story.',
            breakdown: [
                { name: 'Completion', score: allVisited ? 100 : 0, maxScore: 100, feedback: allVisited ? 'All pages visited' : 'Not all pages visited' },
            ],
            skills: [{ key: `story_reader:${String(activity.id).slice(0, 8)}`, label: 'Story Reader' }],
            label: 'Story Reader Score',
        };
    }
}
exports.CompletionEvaluator = CompletionEvaluator;
